import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{ scale: number }>`
	transform: scale(${(props) => props.scale});
	font-size: 10px;
	width: 34.3em;
	background-color: #fff;
	border-radius: 2.4em;
	position: relative;
	overflow: hidden;
`;

export const Header = styled.div`
	height: 17.6em;
	position: relative;
`;

export const Background = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const Body = styled.div`
	padding: 2em;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1.6em;
	margin: 0 auto;
`;

export const Title = styled.span`
	color: #113b62;
	text-align: center;
	font-family: "Baloo";
	font-size: 3em;
	font-style: normal;
	font-weight: 400;
	line-height: 0.966em;
`;

export const Description = styled.span`
	color: #333;
	text-align: center;
	font-family: "Inter";
	font-size: 1.6em;
	font-style: normal;
	font-weight: 500;
	line-height: 1.25em;
`;

export const Button = styled(ThemeButton)`
	font-size: 2.1em;
	width: 13.428em;
`;
